import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type UploadStatusApi = {
  uploadingCount: number;
  isUploading: boolean;
  startUpload: () => void;
  finishUpload: () => void;
};

const UploadStatusContext = createContext<UploadStatusApi | null>(null);

export function UploadStatusProvider({ children }: { children: ReactNode }) {
  const [uploadingCount, setUploadingCount] = useState(0);

  const value = useMemo<UploadStatusApi>(() => {
    const startUpload = () => setUploadingCount((c) => c + 1);
    const finishUpload = () =>
      setUploadingCount((c) => {
        const next = c - 1;
        return next < 0 ? 0 : next;
      });

    return {
      uploadingCount,
      isUploading: uploadingCount > 0,
      startUpload,
      finishUpload,
    };
  }, [uploadingCount]);

  return (
    <UploadStatusContext.Provider value={value}>
      {children}
    </UploadStatusContext.Provider>
  );
}

export function useUploadStatus() {
  return useContext(UploadStatusContext);
}
